import { Component, Input } from '@angular/core';

@Component({
  selector: 'status-label',
  templateUrl: './statusLabel.component.html',
  styleUrls: ['./statusLabel.component.less']
})

export class StatusLabelComponent {

  @Input()
  public active: boolean;

  @Input()
  public activeText: string;

  @Input()
  public inactiveText: string;

  constructor() {
  }

  getActiveText() {
    return this.activeText;
  }

  getInactiveText() {
    return this.inactiveText;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/common/statusLabel/statusLabel.component.ts